export default {
  DECREASE_BY_PERCENT: 'decrease_by_percent',
  INCREASE_BY_PERCENT: 'increase_by_percent',
  DECREASE_BY_AMOUNT: 'decrease_by_amount',
  INCREASE_BY_AMOUNT: 'increase_by_amount',
};
